import { ResendOtpOption } from '../../domain/entities/ResendOtpOption';

export const AuthAssets = {
  desktopBanner: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/auth_creative_430f27cda5/auth_creative_430f27cda5.png',
    alt: 'Auth Desktop',
  },
  mobileBanner: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/auth_image_mob_05e47cdef3/auth_image_mob_05e47cdef3.png',
    alt: 'Auth Mobile',
  },
  crossBlackIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/cross_black_3f63a93cc1/cross_black_3f63a93cc1.svg',
    alt: 'Cross Black',
  },
  userIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/user_filled_black_7bba9e9360/user_filled_black_7bba9e9360.svg',
    alt: 'user',
  },
  callIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/call_Filled_753ba7fdd8/call_Filled_753ba7fdd8.svg',
    alt: 'phone',
  },
  mailIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/mail_16c56ebfcf/mail_16c56ebfcf.png',
    alt: 'mail',
  },
} as const;

export const AuthTexts = {
  agreementPolicy: `By proceeding, you agree to the [terms of services](/terms-of-service) and [privacy policy](/privacy-policy)`,
  otpInvalid: 'Invalid OTP',
  invalidMobile: 'Invalid phone number',
  submitCta: 'Continue',
  loginModal: {
    title: 'Login to Porter',
    description:
      'Please fill in the details, so we can provide you with the best of our services',
    phonePlaceholder: 'Enter your phone number',
    errorMessage: 'Something went wrong. Please try again.',
  },
  signupModal: {
    title: 'Welcome! 👋',
    description:
      'Sign in or make an account to complete your order with us.',
    namePlaceholder: 'Enter your name',
    phonePlaceholder: 'Enter your phone',
    emailPlaceholder: 'Enter your email',
    whatsappConsent: 'Receive updates via WhatsApp',
  },
  otpModal: {
    title: 'Verify your account',
    otpSentMessage: 'OTP sent to',
    otpSentMessageFull: 'A one time password (OTP) is sent to',
    changeMobile: 'Change',
    errorMessage: 'Something went wrong. Please try again.',
    cta: 'Verify my account',
    resendOtp: {
      notReceived: "Didn't receive the OTP?",
      resend: 'Resend',
      resendIn: 'Resend in',
      tooManyAttempts: 'Too many attempts, try again in an hour',
    },
  },
  resendOptionsModal: {
    title: 'Resent OTP via',
    resendConfirmBtn: 'Continue',
    resendOptions: [
      {
        content: {
          image: {
            src: 'https://dom-content-vault-prod-cdn-assets.porter.in/chat_outline_cd042d7993/chat_outline_cd042d7993.svg',
            alt: 'sms icon',
            width: 28,
            height: 28,
          },
          text: 'Text SMS',
          subtext: 'Ensure a stable signal',
        },
        value: 'SMS' as ResendOtpOption,
      },
      {
        content: {
          image: {
            src: 'https://dom-content-vault-prod-cdn-assets.porter.in/whatsapp_outline_e0cede679b/whatsapp_outline_e0cede679b.svg',
            alt: 'whatsapp icon',
            width: 24,
            height: 24,
          },
          text: 'Whatsapp',
          subtext: 'Ensure a stable data / WiFi connection',
        },
        value: 'Whatsapp' as ResendOtpOption,
      },
    ],
  },
} as const;

export const SignupTNCCmsData = {
  title: 'Terms & Conditions',
  description:
    'Please review and accept our Terms & Conditions to create your account.',
  agreeAllText: 'I agree to all the following :',
  closeIcon: {
    src: 'https://dom-content-vault-prod-cdn-assets.porter.in/close_default_09a3b01de0/close_default_09a3b01de0.svg',
    alt: 'Terms & Conditions Close',
  },
  confirmText: 'Confirm',
} as const;
